// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"8927f7b5","782":"ecb3aeb7"}[chunkId] + ".chunk.css";
};